import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function TrendingSection() {
  const trendingArticles = articles.filter((a) => a.trending).slice(0, 6);

  return (
    <aside className="bg-background-50 rounded-xl border border-background-200/70 p-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-7 h-7 flex items-center justify-center bg-accent-500 rounded-md">
          <i className="ri-fire-line text-white text-sm"></i>
        </div>
        <h3 className="text-base font-bold font-heading text-foreground-900">
          热门爆料
        </h3>
      </div>
      <div className="space-y-0">
        {trendingArticles.map((article, index) => (
          <Link
            key={article.id}
            to={`/article/${article.slug}`}
            className={`flex items-start gap-3 py-3 no-underline group ${
              index < trendingArticles.length - 1 ? 'border-b border-background-200/50' : ''
            }`}
          >
            <span
              className={`flex-shrink-0 w-6 h-6 flex items-center justify-center rounded text-xs font-bold ${
                index === 0
                  ? 'bg-primary-500 text-white'
                  : index === 1
                  ? 'bg-accent-500 text-white'
                  : index === 2
                  ? 'bg-secondary-500 text-white'
                  : 'bg-background-100 text-foreground-500'
              }`}
            >
              {index + 1}
            </span>
            <div className="min-w-0 flex-1">
              <h4 className="text-sm text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug">
                {article.title}
              </h4>
              <span className="text-xs text-foreground-500 mt-1 block">
                {(article.views / 10000).toFixed(1)}万阅读
              </span>
            </div>
          </Link>
        ))}
      </div>
    </aside>
  );
}